export default {
  getRestaurantReports: "GET_RESTAURANT_REPORTS",
  getRestaurantReportsSuccess: "GET_RESTAURANT_REPORTS_SUCCESS",
  getRestaurantReportsFailed: 'GET_RESTAURANT_REPORTS_FAILED'
}